import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "text-fau-blue text-2xl" }
const _hoisted_3 = { class: "flex items-center gap-x-5 text-fau-blue mt-8" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitPreviewScreen',
  props: {
    answeredQuestions: {},
    isMobile: { type: Boolean },
    submit: { type: Function }
  },
  setup(__props: any) {



function getLabelFromAnswer(options: any, answer: any) {
    return options.filter((o: any) => o.value == answer)[0].label;
}

function FileNameFromAnswer(answer: FileList) {
    var fileNames = [];
    for (let i = 0; i < answer.length; i++) {
        const file = answer.item(i);

        fileNames.push(file?.name);
    }
    return fileNames.join(",");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-8 text-fau-blue-bright" }, [
      _createElementVNode("h1", { class: "text-4xl" }, "Almost there..."),
      _createElementVNode("p", { class: "text-fau-silver text-lg" }, [
        _createTextVNode(" Please "),
        _createElementVNode("span", { class: "underline underline-offset-4 decoration-2 decoration-fau-red" }, "review"),
        _createTextVNode(" your answers before submitting! ")
      ])
    ], -1)),
    _createElementVNode("div", null, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answeredQuestions.slice(
                    _ctx.answeredQuestions.length > 1 ? 1 : 0
                ), (q, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "mb-4 pb-4 border-b border-b-fau-gray"
          }, [
            _createElementVNode("p", {
              class: "text-fau-blue-bright text-lg mb-2",
              innerHTML: q.title
            }, null, 8, _hoisted_1),
            _createElementVNode("p", _hoisted_2, [
              (q.options && q.options.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(getLabelFromAnswer(q.options, q.answer)), 1)
                  ], 64))
                : (q.type == 'FlowFormFileType')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(FileNameFromAnswer(q.answer)), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(q.answer), 1)
                    ], 64))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "bg-fau-blue-bright text-white p-5",
        ref: "button",
        type: "button",
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", null, "Press to Submit", -1)
      ]), 512),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "border border-black w-10 h-0" }, null, -1)),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, "Press Enter")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})